import React, { FunctionComponent } from 'react'
import classNames from 'classnames'
import styles from './Alerts.module.css'
import globalStyles from '@/styles/templates/GlobalNotifications.module.css'
import StringToReactNode from '@/app/_components/StringToReactNode/StringToReactNode'
import TXT from '@/messages'

type ToasterNotificationProps = {
  notification: Transformed.Notification
  onDismiss: () => void
}

/**
 * NOTE:
 * Notifications differ from Announcements in that they are dismissible
 *
 * Toaster notifications appear in toasts
 */

export const ToasterNotification: FunctionComponent<ToasterNotificationProps> = ({
  notification,
  onDismiss,
}: ToasterNotificationProps) => (
  <div className={styles.ToasterWrapper} data-testid="toast-wrapper">

    <div className={classNames(
      styles.ToasterContent,
      globalStyles.Alert,
      {
        [globalStyles.Warning]: notification.priority === 'Medium',
        [globalStyles.Error]: notification.priority === 'High',
      },
    )}
    >
      <div className={styles.ActionBar}>
        <div className={styles.ActionBarTitle}>{notification.title}</div>
        <button
          type="button"
          onClick={onDismiss}
          data-testid="toast-close"
          aria-label={TXT.buttons.ariaDismissNotification}
          className={classNames(
            'btn-unstyled',
            styles.ActionBarClose,
            styles.ToasterContentClose,
          )}
        >
          ✕
        </button>
      </div>
      <StringToReactNode incomingString={notification.content} />
    </div>
  </div>
)
